export const MODAL_TYPE_IMAGE = 'image';
export const MODAL_TYPE_VIDEO = 'video';
export const MOBILE_TYPE_IMAGE = 'answer_image_mobile';
export const DESKTOP_TYPE_IMAGE = 'answer_image_desktop';
export const MOBILE_TYPE_IMAGE_FIRST_INDEX = 'answer_image_mobile_1';
export const MOBILE_TYPE_VIDEO = 'answer_video_mobile';
export const ANSWER_STATUS_VOTED = 'voted';
export const ANSWER_STATUS_VOTE_PENDING = 'vote_pending';
export const ANSWER_STATUS_DISABLED = 'disabled';
export const ANSWER_STATUS_SELECTED = 'selected';
export const ANSWER_STATUS_UNSELECTED = 'unselected';
export const VOTE_STATUS_ACCEPTED = 'accepted';
export const VOTE_STATUS_CREATED = 'created';
export const VOTE_STATUS_PROCESSING = 'processing';
export const SURVEY_ANSWER_MEDIA_CAROUSEL_HEIGHT = 390;
export const SURVEY_ANSWER_MEDIA_LIMIT = 6;

export type AnswerStatusType =
	| typeof ANSWER_STATUS_DISABLED
	| typeof ANSWER_STATUS_SELECTED
	| typeof ANSWER_STATUS_UNSELECTED
	| typeof ANSWER_STATUS_VOTE_PENDING
	| typeof ANSWER_STATUS_VOTED;

export type SurveyAnswerProps = {
	hasModalFor?: ModalTypes;
	id: string;
	mediaItems?: Array<SurveyMedia>;
	onAnswerPress: (answerId: string) => void;
	onImageContainerPress?: () => void;
	showRadioButton: boolean;
	status: AnswerStatusType;
	testID: string;
	text?: string;
	thumbnailUrl?: string;
};

export type SurveyMedia = {
	description?: string;
	dimensions?: { height: number; width: number };
	mediaType: 'image' | 'video';
	thumbnailUrl: string;
	url: string;
};

export type UseSurveyAnswerGroupProps = {
	hasUserVoted: boolean;
	isSurveyExpired: boolean;
	isUserVotePendingBlockchain: boolean;
	onAnswerChange: (answerId: string) => void;
	userCanVote: boolean;
};

export type ModalTypes = typeof MODAL_TYPE_IMAGE | typeof MODAL_TYPE_VIDEO | undefined;

export const AnimationStatus = {
	ANIMATED: 'animated',
	FINISHED_FAILURE: 'finishedFailure',
	FINISHED_SUCCESS: 'finishedSuccess',
	OFF: 'off'
} as const;
